<template>
  <div class="pt-4 px-2">
    <div class="li-tabela">
      <v-data-table
        :headers="colunas"
        :items="itensOrdenados"
        :total-items="totalItens"
        :loading="carregando"
        :pagination.sync="paginacao"
        hide-actions
        no-data-text="Nenhum participante encontrado"
        class="az-table-list"
      >
        <template slot="items" slot-scope="props">
          <td>
            <div class="nobr">{{ props.item.classificacao ? props.item.classificacao + 'º' : '--' }}</div>
          </td>
          <td>
            <div class="nobr"><strong>{{ props.item.fornecedor.razaoSocial }}</strong></div>
          </td>
          <td>
            <div class="nobr">{{ props.item.fornecedor.cpfCnpj }}</div>
          </td>
          <td>
            <span v-if="props.item.dataInteresse">{{ props.item.dataInteresse | az-date('DD/MM/YYYY HH:mm:ss') }}</span>
            <span v-else>-- / -- / --</span>
          </td>
          <td>
            <span v-if="props.item.dataCredenciamento">{{ props.item.dataCredenciamento | az-date('DD/MM/YYYY HH:mm:ss') }}</span>
            <span v-else>-- / -- / --</span>
          </td>
          <td>
            <v-chip small :color="chipCor(props.item.situacao)" text-color="white">{{ traduzirSituacao(props.item.situacao) }}</v-chip>
          </td>
          <td align="center">
            <v-tooltip top>
              <span slot="activator">
                <v-btn icon small :disabled="!podeBaixarDocumentacao(props.item)" @click="baixarDocumentacao(props.item)">
                  <v-icon>get_app</v-icon>
                </v-btn>
              </span>
              <span>{{ tooltipTexto(props.item) }}</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
      <div class="az-pagination">
        <v-pagination v-model="paginacao.page" :length="paginas"/>
        <div class="az-select-pagination">
          <span>Linhas por página:</span>
          <v-select :items="linhasPorPagina" v-model="paginacao.rowsPerPage"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { actionTypes } from '@/core/constants'
import { mapState } from 'vuex'

export default {
    name: 'CredenciamentoVisualizacaoResultado',
    data () {
        return {
            licitacaoId: null,
            carregando: false,
            totalItens: 0,
            paginas: 0,
            paginacao: {
                page: 1,
                rowsPerPage: 10
            },
            linhasPorPagina: [10, 25, 50, 100],
            itens: [],
            colunas: [
                { value: 'classificacao', text: 'Classificação', align: 'left', sortable: false, class: 'primary--text', width: '10%' },
                { value: 'participante', text: 'Participante', align: 'left', sortable: false, class: 'primary--text', width: '30%' },
                { value: 'documento', text: 'Documento Identificador', align: 'left', sortable: false, class: 'primary--text', width: '20%' },
                { value: 'dataInteresse', text: 'Data do Interesse', align: 'left', sortable: false, class: 'primary--text', width: '15%' },
                { value: 'dataCredenciamento', text: 'Data do Credenciamento', align: 'left', sortable: false, class: 'primary--text', width: '15%' },
                { value: 'situacao', text: 'Situação', align: 'left', sortable: false, class: 'primary--text', width: '10%' },
                { value: 'documentacao', text: 'Documentação', align: 'center', sortable: false, class: 'primary--text', width: '10%' }
            ]
        }
    },
    computed: {
        ...mapState(['licitacao']),
        itensOrdenados () {
            const comClassificacao = this.itens.filter(i => i.classificacao !== null && i.classificacao !== undefined)
            const semClassificacao = this.itens.filter(i => i.classificacao === null || i.classificacao === undefined)

            comClassificacao.sort((a, b) => a.classificacao - b.classificacao)
            semClassificacao.sort((a, b) => {
                const da = a.dataCredenciamento ? new Date(a.dataCredenciamento).getTime() : 0
                const db = b.dataCredenciamento ? new Date(b.dataCredenciamento).getTime() : 0
                return db - da
            })

            return [...comClassificacao, ...semClassificacao]
        }
    },
    async created () {
        this.licitacaoId = Number(this.$route.params.id)
        await this.buscarResultado()
    },
    watch: {
        'paginacao.page': function () {
            this.buscarResultado()
        },
        'paginacao.rowsPerPage': function () {
            this.paginacao.page = 1
            this.buscarResultado()
        }
    },
    methods: {
        tooltipTexto (item) {
            if (item && (item.situacao !== 'CREDENCIADO' && item.situacao !== 'NAO_CREDENCIADO')) {
                return 'Documentação indisponível para participantes não habilitados'
            }
            return 'Download da documentação de habilitação'
        },
        async buscarResultado () {
            this.carregando = true
            try {
                const page = this.paginacao && this.paginacao.page ? this.paginacao.page : 1
                const size = this.paginacao && this.paginacao.rowsPerPage ? this.paginacao.rowsPerPage : 10
                const { solicitacoes, totalElements, totalPages } = await this.$store.dispatch(actionTypes.BUSCAR_RESULTADO_CREDENCIAMENTO_PUBLICO, {
                    licitacaoId: this.licitacaoId,
                    paginacao: { page, size }
                })
                this.itens = solicitacoes || []
                this.totalItens = totalElements || this.itens.length
                this.paginas = totalPages || 0
            } finally {
                this.carregando = false
            }
        },
        traduzirSituacao (s) {
            const m = {
                CREDENCIADO: 'Credenciado',
                NAO_CREDENCIADO: 'Não Credenciado',
                AGUARDANDO_ANALISE: 'Aguardando Análise',
                REENVIADO: 'Reenviado',
                EM_ELABORACAO: 'Em Elaboração'
            }
            return m[s] || s
        },
        chipCor (s) {
            if (s === 'CREDENCIADO') return 'green'
            if (s === 'NAO_CREDENCIADO') return 'red'
            return 'grey'
        },
        podeBaixarDocumentacao (item) {
            return item && (item.situacao === 'CREDENCIADO' || item.situacao === 'NAO_CREDENCIADO')
        },
        async baixarDocumentacao (item) {
            try {
                const fornecedorId = (item && item.fornecedor && item.fornecedor.id) || item.fornecedorId
                const nomeFornecedor = (item && item.fornecedor && item.fornecedor.razaoSocial) || 'documentacao'
                await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTACAO_FORNECEDOR_CREDENCIAMENTO, {
                    licitacaoId: this.licitacaoId,
                    fornecedorId,
                    nomeFornecedor
                })
            } catch (e) {
                return null
            }
        },
        extrairNumeracao (v) {
            return (v || '').toString().replace(/\D/g, '')
        }
    }
}
</script>
<style lang="stylus">
.nobr
  white-space nowrap
  hyphens none
</style>